"use client"

import type { FunctionComponent, PropsWithChildren } from "react"

import { QueryClientProvider } from "@tanstack/react-query"
import { useState } from "react"

import { createComponentQueryClient } from "@/modules/queryClient/createComponentQueryClient"

export const QueryClientProviderWrapper: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [queryClient] = useState(() => createComponentQueryClient())

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
